var _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 51.624,
    width: 64,
    height: 7.2668,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.9962,
    cy: 16.008,
    r: 5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 51.624,
    width: 64,
    height: 7.2668,
    fill: "#F1B31C"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCEA2B",
    d: "M7,11c2.7614,0,5,2.2386,5,5s-2.2386,5-5,5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCEA2B",
    d: "M65,21c-2.7614,0-5-2.2386-5-5s2.2386-5,5-5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCEA2B",
    d: "M64.9674,17.4945c0,9.0811-7.3617,16.4428-16.4428,16.4428H48.238 c-9.0811,0-11.4428-7.3617-11.4428-16.4428h-2.0738c0,9.0811-2.3617,16.4428-11.4428,16.4428h0.1643 c-5.3121,0-10.0359-2.519-13.0419-6.4277C8.2681,24.7363,7,21.2635,7,17.4945V11v40.624h58V11"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.9962,
    cy: 16.008,
    r: 5,
    fill: "#FCEA2B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "skin"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "skin-shadow"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 51.624,
    width: 64,
    height: 7.2668,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    points: "7,11 7,51.624 65,51.624 65,11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M7,11c2.7614,0,5,2.2386,5,5s-2.2386,5-5,5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M23.4428,33.9373c-5.3121,0-10.0359-2.519-13.0419-6.4277C8.2681,24.7363,7,21.2635,7,17.4945"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M64.9674,17.4945c0,9.0811-7.3617,16.4428-16.4428,16.4428"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.9962,
    cy: 16.008,
    r: 5,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M65,21c-2.7614,0-5-2.2386-5-5s2.2386-5,5-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 51.624,
    width: 64,
    height: 7.2668,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M7,11c2.7614,0,5,2.2386,5,5s-2.2386,5-5,5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M65,21c-2.7614,0-5-2.2386-5-5s2.2386-5,5-5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M34.597,20.8744c-0.5876,7.4597-3.3959,13.0629-11.3184,13.0629h0.1643c-5.3121,0-10.0359-2.519-13.0419-6.4277 C8.2681,24.7363,7,21.2635,7,17.4945V11v40.624h58V11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M64.9674,17.4945c0,9.0811-7.3617,16.4428-16.4428,16.4428H48.238c-7.9061,0-10.7191-5.5799-11.3147-13.0163"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.9962,
    cy: 16.008,
    r: 5,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.9cb74f6eff8f86f2c4a698ea2da48d06.svg";
export { ForwardRef as ReactComponent };